"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'contextTV';
exports.SET_DATE_STRING = exports.namespace + "/SET_DATE_STRING";
exports.SET_IS_MENU_OPEN = exports.namespace + "/SET_IS_MENU_OPEN";
exports.SET_IS_DISABLED_RCU = exports.namespace + "/SET_IS_DISABLED_RCU";
exports.SET_IS_ON_SCREEN_GUIDE_VISIBLE = exports.namespace + "/SET_IS_ON_SCREEN_GUIDE_VISIBLE";
exports.SET_LONG_PRESS_MODE_ID = exports.namespace + "/SET_LONG_PRESS_MODE_ID";
exports.SET_KEYBOARD_OPEN = exports.namespace + "/SET_KEYBOARD_OPEN";
exports.SET_IS_IP_FAILOVER = exports.namespace + "/SET_IS_IP_FAILOVER";
//# sourceMappingURL=constants.js.map